<template>
    <ol-vector-layer :zIndex="2000">
        <ol-source-vector :features="editedFeatures" v-if="flen">
            <ol-interaction-modify v-if="flen" 
            :pixelTolerance="pixelTolerance"
            ></ol-interaction-modify>
            <vector-edit-styles />
        </ol-source-vector>
    </ol-vector-layer>

    <v-slide-y-reverse-transition>

        <v-card id="bottomSheet" theme="dark" :rounded="0" class="" style="">

            <v-card-title>Modifica geometria
            </v-card-title>
            <v-card-text class="text-yellow">
                <!-- <div v-if="selectedOLFeature?.properties?.model" -->
                <div v-if="gtype === 'Point'">
                    Trascina il punto per modificare la posizione
                </div>
                <div v-if="gtype === 'LineString'">
                    Trascina i punti per modificare la linea.<br>
                    Crea nuovi punti, trascinando la linea in un punto distante dai vertici.
                </div>
                <div v-if="gtype === 'Polygon'">
                    Trascina i punti per modificare la linea.<br>
                    Crea nuovi punti, trascinando la linea in un punto distante dai vertici.
                </div>
            </v-card-text> 

            <v-card-actions class="d-flex flex-column justify-center">

                <v-btn variant="outlined" color="white" size="large" @click="confirmNewGeometry"
                    class="">
                    <v-icon class="mr-2" color="green">mdi-check</v-icon>
                    Conferma
                </v-btn>
                <v-btn size="large" variant="outlined" color="white"
                    @click="dismissNewGeometry" class="">
                    <v-icon class="mr-2" color="red-darken-2">mdi-close</v-icon>
                    Annulla
                </v-btn>

            </v-card-actions>
        </v-card>
    </v-slide-y-reverse-transition>


</template>

<script setup>
import { ref, computed, onMounted } from "vue"
import Feature from 'ol/Feature.js'

import VectorEditStyles from  "@/components/map/layers/VectorEditStyles.vue"


import { useDisplay } from 'vuetify'
const { mobile } = useDisplay()

const emit = defineEmits(["newGometry"])

const props = defineProps({
    selectedOLFeature: {
        type: Object,
        required: true
    },
})


const pixelTolerance = computed(() => {
    if (mobile) return 20
    return 10
})


const editedFeatures = ref([])
const flen = computed(() => {
    return editedFeatures.value.length
})

const gtype = computed(() => {
    if (!flen.value) return null
    return editedFeatures.value[0].getGeometry().getType()
})


const confirmNewGeometry = () => {

    const GeoJSONGeometry = {
        type: editedFeatures.value[0].getGeometry().getType(),
        coordinates: editedFeatures.value[0].getGeometry().clone().transform('EPSG:3857', 'EPSG:4326').getCoordinates()
    }

    emit("newGometry", GeoJSONGeometry)
}
const dismissNewGeometry = () => {
    emit("newGometry", null)
}

const editFeature = async () => {

    const newFeature = new Feature({
        geometry: props.selectedOLFeature.getGeometry().clone(),
        name: 'New shape',
    });

    editedFeatures.value = [newFeature]
    // await nextTick(() => {
    // })
    // await nextTick(() => {
    //     // console.log("🌍 ", editedFeatures.value)
    // })
    // interactionMode.value = "edit"
}

const regularFontSize = 40
const todayFontSize = 72

const zIndex = ref(1)
// if (props.selected) {
// }




onMounted(() => {
    editFeature()
})




</script>

<style scoped>
#bottomSheet {
    margin: 0 !important;
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 1004;
}
</style>
